import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import { ClickMarketTrendsLink_ForYouHeuristic } from '@sorare/core/src/protos/events/platform/web/events';

import { PlayerRecommendationRow } from '../PlayerRecommendationRow';
import { PopularChip } from '../chips/PopularChip';
import { NoWrap } from '../ui';
import { Popular_so5League } from './__generated__/index.graphql';

type Props = {
  so5League: Nullable<Popular_so5League>;
  loading: boolean;
  onStatsClick: (slug: string) => void;
  so5LeagueSlug: string;
};

export const Popular = ({
  so5League,
  loading,
  onStatsClick,
  so5LeagueSlug,
}: Props) => {
  const players =
    so5League?.popular?.map(({ anyPlayer }) => anyPlayer).slice(0, 5) || [];

  return (
    <PlayerRecommendationRow
      title={
        <FormattedMessage
          defaultMessage="Popular{br}<noWrap>Players</noWrap>"
          id="market.trending.forYou.popular.title"
          values={{
            br: <br />,
            noWrap: chunks => <NoWrap>{chunks}</NoWrap>,
          }}
        />
      }
      background="linear-gradient(267deg, #AC5D6F -17.21%, #2D2AD1 99.59%)"
      chip={<PopularChip />}
      loading={loading}
      players={players}
      onStatsClick={onStatsClick}
      eventProperties={{
        heuristic: ClickMarketTrendsLink_ForYouHeuristic.POPULAR,
        so5LeagueSlug,
      }}
    />
  );
};

Popular.fragments = {
  so5League: gql`
    fragment Popular_so5League on So5League {
      slug
      popular: topRecommendations(
        recommendationEngine: POPULAR
        sport: $sport
        positions: $positions
      ) {
        id
        playerSlug
        anyPlayer {
          slug
          ...PlayerRecommendationRow_anyPlayer
        }
      }
    }
    ${PlayerRecommendationRow.fragments.anyPlayer}
  ` as TypedDocumentNode<Popular_so5League>,
};
